import { render, staticRenderFns } from "./TableWrapper.vue?vue&type=template&id=e7bdd668&scoped=true"
import script from "./TableWrapper.vue?vue&type=script&lang=js"
export * from "./TableWrapper.vue?vue&type=script&lang=js"
import style0 from "./TableWrapper.vue?vue&type=style&index=0&id=e7bdd668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bdd668",
  null
  
)

export default component.exports